import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTiktok,
  faYoutube,
  faFacebook,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

// export const COL_1_LINKS = [
//   { name: "Future Students", url: "https://uac.edu.au/future-applicants" },
//   {
//     name: "Current Applicants",
//     url: "https://uac.edu.au/current-applicants"
//   },
//   { name: "UAC Shop", url: "https://www25.uac.edu.au/uacshop/" },
//   { name: "Accessibility", url: "https://google.com/" } // no link?
// ];

export const COL_1_LINKS = [
  {
    name: "ATAR explained",
    url: "https://uac.edu.au/future-applicants/atar",
  },
  {
    name: "Uni admission criteria",
    url: "https://uac.edu.au/future-applicants/admission-criteria",
  },
  {
    name: "Pathways to uni",
    url: "https://uac.edu.au/future-applicants/admission-criteria/pathways-to-university",
  },
  {
    name: "How to apply through UAC",
    url: "https://uac.edu.au/future-applicants/how-to-apply-for-uni",
  },
  {
    name: "Privacy and legal info",
    url: "https://uac.edu.au/about/privacy-legal",
  },
];

export const COL_2_LINKS = [
  // {
  //   name: "Download iOS App",
  //   url: "https://itunes.apple.com/au/app/my-uac/id1057927265"
  // },
  // {
  //   name: "Download Android App",
  //   url: "https://play.google.com/store/apps/details?id=au.edu.uac.uapply"
  // },
];

export const SOCIAL_LINKS = [
  {
    name: "UAC info facebook",
    icon: <FontAwesomeIcon icon={faFacebook} />,
    url: "https://facebook.com/uacinfo/",
  },
  // {
  //   name: "twitter",
  //   icon: "fab fa-twitter",
  //   url: "https://twitter.com/UACinfo/"
  // },
  {
    name: "UAC info instagram",
    icon: <FontAwesomeIcon icon={faInstagram} />,
    url: "https://instagram.com/uacinfo/",
  },
  // {
  //   name: "snapchat",
  //   icon: "fab fa-snapchat",
  //   url: "https://snapchat.com/add/uacinfo"
  // },
  {
    name: "UAC info youtube",
    icon: <FontAwesomeIcon icon={faYoutube} />,
    url: "https://youtube.com/UACdigital",
  },
  {
    name: "UAC info tiktok",
    icon: <FontAwesomeIcon icon={faTiktok} />,
    url: "https://tiktok.com/@uacapply",
  },
];
